/* eslint-disable func-names */
import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import logoBlack from 'assets/resources/logo_black.svg';
// eslint-disable-next-line import/no-unresolved
import logoWhite from 'assets/resources/logo_white.svg';
import ImgHTML from './ImgHTML';

const Header = ({ lightMode }) => {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [whiteLogo, setWhiteLogo] = useState(true);
  const [transparentBg, setTransparentBg] = useState(true);
  const [whiteButton, setWhiteButton] = useState(true);

  function useWhiteLogo(isScrolled, isHamburgerOpen) {
    const shouldUseWhiteLogo = !isScrolled && !isHamburgerOpen && !lightMode;
    setWhiteLogo(shouldUseWhiteLogo);
  }
  function useTransparentBg(isScrolled, isHamburgerOpen) {
    const shouldUseTransparentBg = !isScrolled && !isHamburgerOpen;
    setTransparentBg(shouldUseTransparentBg);
  }
  function useWhiteButton(isScrolled, isMobileScreen, isHamburgerOpen) {
    const shouldUseWhiteButton =
      !isScrolled && isMobileScreen && !isHamburgerOpen;
    setWhiteButton(shouldUseWhiteButton);
  }

  useEffect(() => {
    function changeNavbar() {
      const scrolled = window.pageYOffset > 0;
      const mobileScreen = window.innerWidth <= 991;

      useWhiteLogo(scrolled, hamburgerOpen);
      useTransparentBg(scrolled, hamburgerOpen);
      useWhiteButton(scrolled, mobileScreen, hamburgerOpen);
    }
    window.addEventListener('scroll', changeNavbar);
    window.addEventListener('orientationchange', changeNavbar);
    window.addEventListener('resize', changeNavbar);

    changeNavbar();
    return () => {
      window.removeEventListener('scroll', changeNavbar);
      window.removeEventListener('orientationchange', changeNavbar);
      window.removeEventListener('resize', changeNavbar);
    };
  }, [hamburgerOpen]);

  const handleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen);
  };

  return (
    <nav
      className={`main-navigation ${transparentBg && !lightMode ? '' : 'bg'}`}
    >
      <div className="container">
        <div className="logo">
          <Link to="/">
            <ImgHTML
              src={whiteLogo ? logoWhite : logoBlack}
              className="basis"
              id="basis-logo"
              alt="Ulam Logo"
              fetchImmediately
            />
          </Link>
        </div>
        <div className="main-menu">
          <div className="navbar navbar-expand-lg navbar-light rounded">
            <button
              onClick={handleHamburger}
              type="button"
              aria-label="hamburger menu"
              className={`navbar-toggle ${hamburgerOpen ? '' : 'collapsed'}`}
              data-toggle="collapse"
              data-target="#navbar"
              id="show-it"
            >
              <span
                className={`icon-bar top-bar ${
                  whiteButton && !lightMode ? '' : 'icon-bar-dark'
                }`}
              />
              <span
                className={`icon-bar middle-bar ${
                  whiteButton && !lightMode ? '' : 'icon-bar-dark'
                }`}
              />
              <span
                className={`icon-bar bottom-bar ${
                  whiteButton && !lightMode ? '' : 'icon-bar-dark'
                }`}
              />
            </button>
            <div
              className={`collapse navbar-collapse ${
                hamburgerOpen ? 'show' : ''
              }`}
              id="navbar"
            >
              <ul className="nav navbar-nav">
                <li className="eh e-link">
                  <Link
                    to="/software-services/"
                    target="_self"
                    className=""
                    activeClassName="active"
                  >
                    Software services
                  </Link>
                </li>
                <li className="eh e-link">
                  <Link
                    to="/case-studies/"
                    target="_self"
                    className=""
                    activeClassName="active"
                  >
                    Case studies
                  </Link>
                </li>
                <li className="eh e-link">
                  <Link
                    to="/about-us/"
                    target="_self"
                    className=""
                    activeClassName="active"
                  >
                    About us
                  </Link>
                </li>
                <li className="eh e-link">
                  <Link
                    to="/blog/"
                    target="_self"
                    className=""
                    activeClassName="active"
                    partiallyActive
                  >
                    Blog
                  </Link>
                </li>
                <li className="eh e-link">
                  <Link
                    to="/careers/"
                    target="_self"
                    className=""
                    activeClassName="active"
                  >
                    Careers
                  </Link>
                </li>
                <li className="eh e-link">
                  <AniLink
                    cover
                    bg="#EAEBF1"
                    to="/contact/"
                    className={`awarded ${lightMode ? 'btn fill' : ''}`}
                  >
                    Contact us
                  </AniLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

Header.propTypes = {
  lightMode: PropTypes.bool
};

Header.defaultProps = {
  lightMode: false
};

export default Header;
